export default __webpack_public_path__ + "static/media/download_methodiek_omgevingsfotos.2ea318bf.pdf";